/* eslint-disable no-unused-vars */
import React from 'react';
import { Box } from '@mui/material';
import HeadingVerySmall from '../../core/typography/headings/very-small/HeadingVerySmall';

import TopBar from '../../core/navigation/top-bar/TopBar';
import Loader from '../../core/loaders/bouncies/Bouncies';
import styles from './LoggedIn.style';

function LoggedIn({ // sidebar,
  children, heading, loading, header,
}) {
  return (
    <>
      <Box sx={styles.container}>
        <TopBar />
        {/* {sidebar || <Sidebar />} */}
        <Box component="main" sx={styles.main}>
          <Box sx={styles.headingsContainer}>
            {header || (
              <Box sx={styles.heading}>
                <HeadingVerySmall text={heading} />
              </Box>
            )}
          </Box>
          {children}
        </Box>
      </Box>
      {loading && <Loader />}
    </>
  );
}

LoggedIn.defaultProps = {
  loading: false,
  header: undefined,
  smallHeading: undefined,
  smallHeadingStyles: undefined,
  heading: '',
};

export default LoggedIn;
